import { EMAIL_SCENARIOS } from '../../constants/emailScenarios';

export const getDefaultScenario = (stage) => {
  if (stage === 'contract_sent') return 'proposal_reminder';
  if (stage === 'closed_won') return 'onboarding';
  if (stage === 'closed_lost') return 're_engagement';
  if (stage === 'appointment_scheduled') return 'first_contact';
  return 'follow_up';
};

export const getScenarioOptions = () => EMAIL_SCENARIOS;
